import { ProtoRequest } from '@lsq-frontend/angular-shared/api-service';

export class GetGroupedInvoiceSummaryForSellerRequest extends ProtoRequest {
    public refSellerKey: string;
    public refGroupedInvoiceKey: string;
    public useScheduledDate: boolean;
    public isCreditMemo?: boolean;

    constructor(obj?: Partial<GetGroupedInvoiceSummaryForSellerRequest>) {
        super();
        if (obj != null) {
            this.refSellerKey = obj?.refSellerKey;
            this.refGroupedInvoiceKey = obj?.refGroupedInvoiceKey;
            this.useScheduledDate = obj?.useScheduledDate || false;
            this.isCreditMemo = obj?.isCreditMemo || false;
        }
    }
}
